import React, { useEffect, useState } from "react";
import { Field } from "formik";
import { Input as InputElement, Content, Ul } from "./styles";
import IField from "../../../../interfaces/field";
import TplGroup from "../tpl-group";

type IProps = any & IField;

const MultipleTextInput = ({
  title,
  placeholder = "Digite e pressione enter p/ adicionar",
  required = false,
  name,
  prefixName = "",
  type,
  onChange,
  ...el
}: IProps): JSX.Element | null => {
  const [inputValue, setInputValue] = useState("");
  const [valuesList, setValuesList] = useState<string[]>([]);

  useEffect(() => {
    if (el.setFieldValue) {
      el.setFieldValue(`${prefixName}${name}`, valuesList.join(", "));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valuesList]);

  useEffect(() => {
    if (el.value) {
      setValuesList(el.value.split(", "));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [el.value]);

  const handleChange = (event: { target: { value: string } }): void => {
    let { value } = event.target;
    if (onChange) {
      onChange(value);
    }
    if (el.validations?.includes("email")) {
      value = event.target.value.replace(/\s/g, "");
    }

    setInputValue(value);
  };

  const handleKeyDown = (event: React.KeyboardEvent): void => {
    if (event.key === "Enter" && inputValue.trim() !== "") {
      setValuesList([...valuesList, inputValue.trim()]);
      setInputValue("");
    }
  };

  const handleRemove = (index: number): void => {
    const newList = valuesList.filter((_, i) => i !== index);
    setValuesList(newList);
  };

  return (
    <TplGroup
      name={`${prefixName}${name}`}
      prefixName={prefixName}
      title={title}
      required={required}
      {...el}
    >
      <Content>
        <Field {...el} type={type || "text"} name={`${prefixName}${name}`}>
          {() => (
            <InputElement
              type={type || "text"}
              required={required}
              placeholder={placeholder || ""}
              onChange={(event: any) => handleChange(event)}
              onKeyDown={handleKeyDown}
              max={el.max}
              disabled={el?.disabled === true}
              maxLength={el.max}
              value={inputValue}
            />
          )}
        </Field>
        <Ul>
          {valuesList.map((value, index) => (
            <li key={index}>
              {value}{" "}
              <button type="button" onClick={() => handleRemove(index)}>
                X
              </button>
            </li>
          ))}
        </Ul>
      </Content>
    </TplGroup>
  );
};

export default MultipleTextInput;
